'use es6';

import * as Actions from 'FormsUI/actions/UserAttributes';
import { Map as ImmutableMap } from 'immutable';
const INIT_STATE = new ImmutableMap();
export function userAttributes(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.RECEIVE_USER_ATTRIBUTE:
      {
        const {
          key,
          value
        } = action;
        return state.merge({
          [key]: value
        });
      }
    default:
      return state;
  }
}